import { useAuthStore } from "@/store/authStore";

export const permissionGuard = (to, from, next) => {
  const authStore = useAuthStore();
  const requiredPermissions = to.meta.permissions || [];

  if (
    requiredPermissions.length &&
    !authStore.hasAllPermissions(requiredPermissions)
  ) {
    return next({ name: "Assets" });
  }

  next();
};